<template>
<div class="video-list container">
    <h1 class="purple">
        שיעורי {{heading}}
    </h1>

    <videos :videos="videosToView"></videos>
</div>
</template>

<script>
import Videos from "@/components/Videos.vue";

export default {
  name: `VideoList`,

  components: {
    Videos
  },
  computed: {
    current() {
      let output = {};
      if (Array.isArray(this.$store.state.initialData.currents)) {
        const cur = this.$store.state.initialData.currents.filter((c) => {
          if (c.id === this.$route.params.cid) {
            return true;
          }
          return false;
        });
        output = cur[0];
      }
      return output;
    },

    videoList() {
      return this.$store.state.videos;
    },

    videosToView() {
      let cur = [];
      if (Array.isArray(this.videoList)) {
        cur = this.videoList.filter((v) => {
          if (v.current === this.current.resource.id) {
            return true;
          }
          return false;
        });
      }
      return cur;
    },

    heading() {
      return this.current.label;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  }
  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.video-list {
  padding-top: 20px;
  h1 {
    padding: 0 15px;
    svg {
      vertical-align: text-bottom;
    }
  }
}

@media screen and (min-width: 1025px) {
  .video-list {
    h1 {
      padding: 0;
    }
  }
}
</style>
